export default function accessListByLoggedUser() {
  return `{
  accessListByUser {
    loggedUser {
      id
      name
      login
      clientId
      clientName
      selectedTermId
      selectedTermName
      photoUrl
      clientSchema
    }
    listOfPermission {
      id
      name
      icon
      route
      key
      children {
        id
        name
        icon
        route
        key
        reportKey
      }
    }
    listOfOperation {
      id
      name
      key
    }
  }
}
`;
}
